module.exports = __webpack_public_path__ + "assets/grotesk-webfont-6885a6e02eeb963b410b6d84c425188a.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/styles/font/grotesk-webfont.ttf
// module id = 676
// module chunks = 1